/* eslint-disable max-lines-per-function */
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Button,
  Drawer,
  DrawerContent,
  DrawerTrigger,
} from '@e2n/ui';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react/jsx-runtime';
import { KalenderByArbeitsbereicheStation } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByArbeitsbereiche/KalenderStation';
import { KalenderArbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByArbeitsbereiche/KalenderArbeitsbereich';

export function StationArbeitsbereichCard({
  kalenderStation,
  arbeitsbereich,
}: {
  kalenderStation: KalenderByArbeitsbereicheStation;
  arbeitsbereich: KalenderArbeitsbereich;
}) {
  const { t } = useTranslation();
  const mitarbeiterInfo =
    dayjs(kalenderStation.station.von).format('DD.MM.YYYY') +
    ' – ' +
    dayjs(kalenderStation.station.bis).format('DD.MM.YYYY') +
    ' ⋅ ' +
    kalenderStation.mitarbeiter.length +
    ' ' +
    t('entities.employee');

  return (
    <Drawer>
      <DrawerTrigger>
        <div className="flex items-center justify-between p-4 bg-white rounded-md cursor-pointer">
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <div className="text-sm">
                <FontAwesomeIcon
                  size="xs"
                  icon={faCircle}
                  color={arbeitsbereich.getBorderColor()}
                />
              </div>
              <div className="text-sm font-semibold">{arbeitsbereich.name}</div>
            </div>
            <div className="text-xs text-neutrals-800">{mitarbeiterInfo}</div>
          </div>
          <Button
            variant="icon"
            size="icon"
            className="text-xl cursor-pointer text-neutrals-700">
            <FontAwesomeIcon icon={faChevronRight} />
          </Button>
        </div>
      </DrawerTrigger>
      <DrawerContent>
        <div className="flex flex-col gap-5 p-4">
          <div className="flex flex-col">
            <div className="flex items-center gap-2">
              <div className="text-sm">
                <FontAwesomeIcon
                  icon={faCircle}
                  color={arbeitsbereich.getBorderColor()}
                  size="xs"
                />
              </div>
              <div className="text-xl font-bold">{arbeitsbereich.name}</div>
            </div>
            <div className="text-sm text-neutrals-800">{mitarbeiterInfo}</div>
          </div>
          {kalenderStation.mitarbeiter.map((m, index) => (
            <Fragment key={m.id}>
              <div className="flex items-center gap-3">
                <Avatar>
                  <AvatarImage
                    alt={m.vorname + ' ' + m.nachname}
                    src={m.imgUrl}
                  />
                  <AvatarFallback>
                    {m.vorname[0].toUpperCase() + m.nachname[0].toUpperCase()}
                  </AvatarFallback>
                </Avatar>
                <div className="flex flex-col gap-1">
                  <div className="text-sm">{m.vorname + ' ' + m.nachname}</div>
                  <div className="text-xs text-neutrals-700">
                    {m.lehrjahr + ' ⋅ ' + m.beruf.abkuerzung}
                  </div>
                </div>
              </div>
              {index < kalenderStation.mitarbeiter.length - 1 && (
                <div className="w-full h-px bg-neutrals-200"></div>
              )}
            </Fragment>
          ))}
        </div>
      </DrawerContent>
    </Drawer>
  );
}
